import { jsx } from "react/jsx-runtime";
import "react";
import Script from "next/script";
import PropTypes from "prop-types";
const SimonScript = ({
  storageEnvironment
}) => {
  const simonStorageConfiguration = {
    Zillow: {
      partnerId: "678699254b5f7e42743738daef1770d6dcf2abd8",
      jsScript: "https://static.simonsignal.com/simon-zil-min.js",
      domain: ".zillow.com"
    },
    ZillowHomeLoans: {
      partnerId: "28cfa166d9458c2837f77348ad8903501ad7c60d",
      jsScript: "https://static.simonsignal.com/simon-zhl-min.js",
      domain: ".zillow.com"
    },
    ZillowSandBox: {
      partnerId: "4b618a5c5579f17752bf385ed61558a58f390f87",
      jsScript: "https://static.simonsignal.com/zil",
      domain: ".zillow.com"
    }
  };
  const {
    partnerId,
    jsScript,
    domain
  } = simonStorageConfiguration[storageEnvironment];
  return /* @__PURE__ */ jsx(Script, { id: `sf_${partnerId}`, children: `
		var _sd = _sd || {};
		_sd.partnerId = '${partnerId}';
		_sd.domain = '${domain}';
		_sd.environment = '${storageEnvironment}';
		_sd.debug = true;
		_sd.behaviors = {};
		(function(s,i,m){
		    w=window;d=document;n='script';l=Array.prototype.slice;
		    w._sd.lib=i;w.SimonData=s;
		    w[s]||(w[s]={
		    send:function(){(w[s].q=w[s].q||[]).push(arguments)},
		    identify:function(){a=l.call(arguments);a.unshift('identify');w[s].send.apply(null,a)},
		    track:function(){a=l.call(arguments);a.unshift('track');w[s].send.apply(null,a)}
		    });
		    t=d.createElement(n);t.src=i;
		    o=d.getElementsByTagName(m)[0];o.parentNode.insertBefore(t,o)
		})('sd','${jsScript}','script');
	 ` });
};
SimonScript.propTypes = {
  storageEnvironment: PropTypes.string.isRequired
};
export {
  SimonScript as default
};
